<template>
  <div>
    <div class="filter-bar mb-sm">
      <breadcrumb></breadcrumb>
      <div class="space"></div>
      <el-button size="small" type="primary" @click="onExport">导出</el-button>
      <el-button slot="reference" size="small" @click="$router.go(-1)"
        >返回</el-button
      >
    </div>
    <div class="content-box">
      <div class="export-box" id="export-box">
        <div class="page face">
          <div class="title">
            <h2>上海市奉贤区{{ userInfo.schoolName }}</h2>
            <h2>“四薪三品二坊”</h2>
            <h2>活动记录本</h2>
          </div>
          <div class="info">
            <h2>
              名&emsp;称：<span style="white-space: nowrap">{{
                groupInfo?.groupName
              }}</span>
            </h2>
            <h2>
              主持人：<span>{{ groupInfo?.leaderName }}</span>
            </h2>
          </div>
          <div class="schoolYear">
            <h2>
              {{ groupInfo?.schoolYear }}学年{{
                groupInfo?.schoolTerm | revertTerm
              }}
            </h2>
          </div>
        </div>
        <div class="page topic newTeacher3">
          <table>
            <caption class="page-title">
              基本情况
            </caption>
            <tbody>
              <tr>
                <td class="label verticalText">
                  {{ groupInfo.groupType | revertType2 }}简介
                </td>
                <td>
                  <div>{{ groupInfo.intro }}</div>
                </td>
              </tr>
              <tr>
                <td class="label verticalText">工作目标</td>
                <td>
                  <div>{{ groupInfo.target }}</div>
                </td>
              </tr>
              <tr>
                <td class="label verticalText">工作任务</td>
                <td>
                  <div>{{ groupInfo.task }}</div>
                </td>
              </tr>

              <tr>
                <td class="label verticalText">工作策略</td>
                <td>
                  <div>{{ groupInfo.plan }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="page topic newTeacher2"
          v-for="(table, index) in researchTableData2"
          :key="'researchTableData2' + index"
        >
          <table>
            <caption class="page-title">
              工作行事历
            </caption>
            <thead>
              <tr>
                <th>时间</th>
                <th>活动内容</th>
                <th>召集人</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="act in table" :key="act.id">
                <td>{{ act.startDate | formatDate }}</td>
                <td>{{ act.actTitle }}</td>
                <td>
                  <span
                    v-for="(user, index) in act.speakUsers"
                    :key="user.userId"
                    >{{ user.userName
                    }}{{ index == act.speakUsers.length - 1 ? "" : "、" }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="page topic newTeacher2"
          v-for="(table, index) in tableData"
          :key="index"
        >
          <table>
            <caption class="page-title">
              学员名单
            </caption>
            <thead>
              <tr>
                <th>姓名</th>
                <th>学科</th>
                <th>教龄</th>
                <th>职称</th>
                <th>备注</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in table" :key="user.id">
                <td>{{ user.userName }}</td>
                <td>{{ user.teacherInfoList | revertTeacherInfoList }}</td>
                <td>{{ user.teacherArchivesDTO?.teachingAge }}</td>
                <td>{{ user.teacherArchivesDTO?.academicTitlesDesc }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="page topic research2"
          v-for="(table, index) in researchTableData"
          :key="table.id"
        >
          <table>
            <caption class="page-title">
              活动记录
            </caption>
            <tbody>
              <tr class="fix-height">
                <td class="label">时间</td>
                <td>
                  {{ table.startDate | formatDate }}～{{
                    table.endDate | formatDate
                  }}
                </td>
                <td class="label">地点</td>
                <td>{{ table.address }}</td>
                <td class="label">缺席</td>
                <td v-if="table.absenceUser.length <= 3">
                  <span
                    v-for="(user, index) in table.absenceUser"
                    :key="user.userId"
                    >{{ user.userName
                    }}{{
                      index == table.absenceUser.length - 1 ? "" : "、"
                    }}</span
                  >
                </td>
                <td v-else>
                  <span
                    v-for="(user, index) in table.absenceUser.slice(0, 3)"
                    :key="user.userId"
                    >{{ user.userName }}{{ index == 2 ? "等" : "、" }}</span
                  >
                </td>
              </tr>
              <tr class="fix-height">
                <td class="label">活动目的与任务</td>
                <td colspan="5" style="height: 100px; text-indent: 2em;" class="left-td">
                  {{ table.actContent }}
                </td>
              </tr>
              <tr>
                <td class="label verticalText">活动过程</td>
                <td colspan="5" style="text-align: left; vertical-align: top">
                  <p class="left-td">
                    <span style="font-weight: 700">活动方案：</span>
                    {{ table.actPlan }}
                  </p>
                  <p class="left-td">
                    <span style="font-weight: 700">活动资料：</span
                    >{{ table.actBasis }}
                  </p>
                  <p class="left-td">
                  <span style="font-weight: 700">活动环节：</span>
                  <ul style="list-style: none;margin: 0">
                    <li
                      style="display: inline"
                      v-for="(node, index) in table.activeNodeTopics"
                      :key="node.id"
                    >
                      {{ index + 1 }}.{{ node.nodeTypeDesc }}
                    </li>
                  </ul>
                  </p>
                </td>
              </tr>
              <tr class="fix-height">
                <td class="label verticalText">活动反思</td>
                <td colspan="5" style="height: 170px" class="left-td">
                  <p >{{ table.sumDescription }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="page topic newTeacher2"
          v-for="(table, index) in honorAwardList"
          :key="'honorAwardList' + index"
        >
          <table>
            <caption class="page-title">
              工作成效<span style="font-size: 20px; letter-spacing: normal"
                >(获奖情况)</span
              >
            </caption>
            <thead>
              <tr>
                <th>序号</th>
                <th>姓名</th>
                <th>奖项名称</th>
                <th>级别和等第</th>
                <th>获奖日期</th>
                <th>备注</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(act, i) in table" :key="act.id">
                <td>{{ index * 10 + i + 1 }}</td>
                <td>{{ act.teacherName }}</td>
                <td>{{ act.title }}</td>
                <td>{{ act.ranksDesc }}</td>
                <td>{{ act.awardDate }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="page small-box">
          <div class="page-title title">学年工作总结</div>
          <div class="content word">
            <pre style="word-break: break-all; white-space: normal;text-indent: 2em;">{{
              groupInfo.summary
            }}</pre>
            <div class="info">
              <span>日期：_______年_______月_______日</span>
            </div>
          </div>
        </div>
        <!-- <div class="page small-box">
          <div class="page-title title">学校意见</div>
          <div class="content">
            <div class="info">
              <span>学校领导&nbsp;_____________________</span
              >&nbsp;(签名)&nbsp;_______&nbsp;年&nbsp;_______&nbsp;月&nbsp;_______&nbsp;日
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { postData, postJson } from "../../../http/fetch";
import Breadcrumb from "@/components/Breadcrumb.vue";
import {
  mapFileIcon,
  mapLinkIcon,
  lookFile,
  downloadUrlFile,
} from "@/utils/index.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";

export default {
  components: {
    Breadcrumb,
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(value).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    revertTerm(val) {
      switch (val) {
        case 1:
          return "第一学期";
        case 2:
          return "第二学期";
      }
    },
    revertTeacherInfoList(val) {
      return Array.from(new Set(val?.map((item) => item.disciplineName))).join(
        "，"
      );
    },
    revertType2(val) {
      switch (val) {
        case "sx":
          return "工程";
        case "sp":
          return "品牌";
        case "ef":
          return "工作坊";
        default:
          return "";
      }
    },
  },
  data() {
    return {
      groupCode: "",
      groupInfo: {
        groupType: "",
      },
      loading: false,
      btnLoading: false,
      tableData: [],
      tableTeacherStatistics: [],
      topicTableData: [],
      topicTableData2: [],
      researchTableData: [],
      researchTableData2: [],
      honorAwardList: [],
    };
  },
  mounted() {
    if (sessionStorage.getItem("groupCode")) {
      this.groupCode = sessionStorage.getItem("groupCode");
      this.getDeatail(this.groupCode);
      this.getProjectGroupTeacherList(this.groupCode);
      this.getGroupActiveList("research", this.groupCode);
      this.getHonorAwardList(this.groupCode);
    }
  },
  computed: {
    ...mapState(["userInfo", "isAdmin"]),
  },
  methods: {
    mapFileIcon,
    mapLinkIcon,
    lookFile,
    async getDeatail(groupCode) {
      this.loading = true;
      await postData("/projectGroup/getProjectGroupInfo", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.groupInfo = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getProjectGroupTeacherList(groupCode) {
      this.loading = true;
      await postData("/projectGroup/getProjectGroupTeacherList", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.tableData = this.setTwoDimensionalArray(res, 20);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getGroupTeacherStatistics(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getGroupTeacherStatistics", {
        groupCode,
      })
        .then((res) => {
          this.tableTeacherStatistics = this.setTwoDimensionalArray(res);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadFile(url, name) {
      //确认下载完成 后 进行下载记录保存
      downloadUrlFile(url, name);
      //保存下载记录
      // postJson("/operator/saveDownloadInfo", {
      // 	infoCode: sessionStorage.getItem("actCode"),
      // 	module: "research",
      // 	operatorId: this.userInfo.userId,
      // 	schoolCode: this.userInfo.schoolCode
      // });
    },
    onExport() {
      const element = document.getElementById("export-box");
      html2canvas(element, {
        allowTaint: true,
        ignoreElements: function () {},
      }).then((canvas) => {
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        let pageHeight = (contentWidth / 592.28) * 841.89;
        let leftHeight = contentHeight;
        let position = 0;
        let imgWidth = 595.28;
        let imgHeight = (595.28 / contentWidth) * contentHeight;
        let pageData = canvas.toDataURL("image/jpeg", 1.0);
        let PDF = new jsPDF("p", "pt", "a4");
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        PDF.save(this.groupInfo.groupName + ".pdf");
      });
    },
    // 转化函数
    setTwoDimensionalArray(list, num = 10) {
      const listResult = []; // 最终返回的二维数组
      for (let i = 0; i < Math.ceil(list.length / num); i++) {
        listResult[i] = [];
        for (let j = 0; j < num; j++) {
          // 如果是最后一个板块
          if (i === Math.ceil(list.length / num) - 1) {
            if (Math.ceil(list.length % num) !== 0) {
              // 只有最后一个板块的数据在余数以内的才赋值
              if (j < Math.ceil(list.length % num)) {
                listResult[i][j] = list[i * num + j];
              }
            } else {
              // 如果刚好整整一个板块，则全部附上值
              listResult[i][j] = list[i * num + j];
            }
          } else {
            listResult[i][j] = list[i * num + j];
          }
        }
      }
      return listResult;
    },
    async getGroupActiveList(actType, groupCode) {
      this.loading = true;
      await postJson("/projectGroup/getGroupActiveList", {
        schoolCodes: this.schoolCodes,
        operatorId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode,
        pageNum: 1,
        pageSize: -1,
        isAdmin: this.isAdmin / 1,
        actType,
        groupCode,
      })
        .then((res) => {
          if (actType == "topic") {
            this.topicTableData = res.records;
            this.topicTableData2 = this.setTwoDimensionalArray(res.records, 20);
          } else {
            this.researchTableData = res.records.map((u) => ({
              ...u,
              absenceUser: u.joinUsers.filter((u) => !u.isSign),
            }));

            this.researchTableData2 = this.setTwoDimensionalArray(
              res.records,
              20
            );
          }
        })
        .catch((e) => {
          if (actType == "topic") {
            this.topicTableData = [];
            this.topicTableData2 = [];
          } else {
            this.researchTableData = [];
            this.researchTableData2 = [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getHonorAwardList(groupCode) {
      this.loading = true;
      await postData("/projectGroup/getHonorAwardList", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.honorAwardList = this.setTwoDimensionalArray(res, 20);
        })
        .catch((e) => {
          this.honorAwardList = null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
@pageW: 794px;
@pageH: 1123px;
@tableGap: 40px;

@fontSize: 16px;
@fontFamily: "宋体";
.content-box {
  .verticalText {
    margin: 0 auto;
    writing-mode: vertical-lr; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
    writing-mode: tb-lr; /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
    letter-spacing: 20px;
  }
  .export-box {
    -webkit-print-color-adjust: exact;
    width: @pageW;
    margin: 0 auto;

    .face {
      position: relative;
      .title {
        padding-top: 150px;
        font-size: 32px;
        h2 {
          font-weight: bold;
          text-align: center;
        }
      }
      .info {
        position: absolute;

        bottom: 150px;
        left: calc(50% - 66px);
        transform: translate(-50%, -50%);
        width: 40%;
        font-weight: 500;
        h2 {
          font-size: 18px;
          position: relative;
          margin: 10px 0;
          &::after {
            content: "";
            position: absolute;
            width: 100%;
            background-color: #000;
            height: 1px;
            bottom: 0;
            left: 66px;
          }
          span {
            position: absolute;
            left: calc(50% + 66px);
            transform: translateX(-50%);
            font-weight: 700;
          }
        }
      }
      .schoolYear {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%);
        font-size: 20px;
        font-weight: 700;
      }
    }
    .user {
      table {
        border-collapse: collapse;
        transform: rotate(90deg);
        transform-origin: 0px 0px;
        position: absolute;
        top: calc(@tableGap / 2);
        left: calc(100% - @tableGap);
        width: calc(@pageH - @tableGap);
        // height: calc(@pageW - @tableGap * 2);
        box-sizing: border-box;
        th,
        td {
          font-size: @fontSize;
          border: 1px solid black;
          text-align: center;
        }
        tr {
          height: calc(calc(@pageW - @tableGap * 2 - 32px) / 11);
          overflow: hidden;
        }
        caption {
          font-size: 24px;
        }
      }
    }
    .topic {
      padding: calc(@tableGap);
      box-sizing: border-box;
      overflow: hidden;
      table {
        width: calc(@pageW - @tableGap * 2);
        height: calc(@pageH - @tableGap * 3 - 2px);
        // height: 100%;
        border-collapse: collapse;
        box-sizing: border-box;
        overflow: hidden;
        caption {
          font-size: 24px;
        }
        th,
        td {
          font-size: @fontSize;
          font-family: @fontFamily;
          border: 1px solid black;
          text-align: center;
          overflow: hidden;
        }
        .label {
          width: 100px;
        }
        .fix-height {
          height: 40px;
        }
      }
    }
    .research2 {
      table {
        tr {
          .left-td {
            text-align: left;
            vertical-align: top;
            margin: 0;
          }
          td {
            line-height: 26px;
          }
          p {
            margin: 0;
            margin-left: 10px;
            text-indent: 2em;
            line-height: 26px;
          }
        }
      }
    }
    .newTeacher {
      table {
        height: unset;
        table-layout: fixed;
        tr {
          &:extend(.verticalText);
          font-size: @fontSize;
          font-family: @fontFamily;
          height: calc(calc(@pageH - @tableGap * 2 - 32px) / 11);
        }
      }
    }
    .newTeacher2 {
      table {
        height: unset;
        table-layout: fixed;
        tr {
          font-size: @fontSize;
          font-family: @fontFamily;
          height: calc(calc(@pageH - @tableGap * 2 - 32px) / 21);
          .verticalText {
            margin: 0 auto;
            writing-mode: vertical-lr; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
            writing-mode: tb-lr; /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
            letter-spacing: 20px;
          }
        }
      }
    }
    .newTeacher3 {
      table {
        table-layout: fixed;
        word-wrap: break-word;
        word-break: break-all;
        overflow: hidden;
        height: calc(calc(@pageH - @tableGap * 2 - 35px)) !important;
        tr {
          font-size: @fontSize;
          font-family: @fontFamily;

          .verticalText {
            margin: 0 auto;
            writing-mode: vertical-lr; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
            writing-mode: tb-lr; /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
            letter-spacing: 20px;
          }
          td {
            max-height: calc(
              calc(@pageH - @tableGap * 2 - 35px) / 4
            ) !important;
            div {
              margin: 0;
              text-align: left;
              text-indent: 2em;
            }
          }
        }
      }
    }
    .small-box {
      width: 100%;
      height: 100%;
      display: flex;
      box-sizing: border-box;
      flex-direction: column;
      padding: @tableGap;
      .title {
        width: 100%;
        height: 30px;
        font-size: 24px;
        text-align: center;
        letter-spacing: 24px;
      }
      .content {
        font-size: @fontSize;
        font-family: @fontFamily;
        position: relative;
        flex: 1;
        margin-top: 10px;
        padding: @tableGap;
        border: 1px solid black;
        white-space: pre;
        .word {
          font-size: @fontSize;
          font-family: @fontFamily;
        }
        .info {
          font-size: @fontSize;
          font-family: @fontFamily;
          position: absolute;
          bottom: 50px;
          right: 50px;
        }
      }
    }

    .page {
      position: relative;
      background-color: #fff;
      height: @pageH;
      width: @pageW;
      .page-title {
        letter-spacing: 28px;
      }
    }
    .outline {
      h1 {
        text-align: center;
        font-weight: bold;
        font-size: 32px;
        letter-spacing: 32px;
        line-height: 96px;
      }
      ul {
        list-style: none;
        margin-left: 30px;
        li {
          font-size: 24px;
          line-height: 48px;
        }
      }
    }
  }
}
</style>